export default __webpack_public_path__ + "6a7b43d27ed768e3212d900d22131d86.png";